import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useMe } from '@crehana/auth';
import trackPageView from "./trackPageView";
/**
 * Returns a function which sends the `page_view` events.
 * You must run this function conditionally inside a useEffect.
 */
export var usePageView = function usePageView(_ref) {
  var type = _ref.type,
    id = _ref.id,
    page = _ref.page,
    pageData = _ref.pageData;
  var _useMe = useMe(),
    me = _useMe.me,
    loading = _useMe.loading,
    error = _useMe.error;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    force = _useState2[0],
    setForce = _useState2[1];
  var sendPageView = function sendPageView() {
    setForce(new Date().getTime());
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (!loading && !error && me && force !== 0) {
      trackPageView({
        type: type,
        id: id,
        page: page,
        user: me,
        pageData: pageData
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, force]);
  return {
    sendPageView: sendPageView
  };
};